export default [
  {
    key: 'name',
    label: 'Name',
  },
];
